module.exports = __webpack_public_path__ + "static/media/Artboard1.acf13d0c.jpg";